import fetch from '@/fetch'
// 我的学术成果图书列表查询
export const bookAchievementListGet = (params) => {
  return fetch({
    method: 'post',
    url: '/console/h5/mine/bookachievement',
    data: params,
    actionTypeCode: '36',
    actionTypeDesc: '我的学术成果图书列表查询',
  })
}

// 我的学术成果论文列表查询
export const articleAchievementListGet = (params) => {
  return fetch({
    method: 'post',
    url: '/console/h5/mine/articleachievement',
    data: params,
    actionTypeCode: '37',
    actionTypeDesc: '我的学术成果论文列表查询',
  })
}
